const HealthCheck = () => {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        justifyContent: "center",
        paddingTop: "4em",
      }}
    >
      <p style={{ fontSize: "18px" }}>App is healthy :)</p>
    </div>
  );
};

export default HealthCheck;
